import React, { useState, useEffect, useRef } from "react";
import "./../../../../src/index.scss";
import "./SongFullScreen.scss";
import draftToHtml from "draftjs-to-html";
import RestClient from "../../../@core/restClient";

import {
  IoChevronDownOutline,
  IoChevronUpOutline,
  IoCloseOutline,
  IoMusicalNotesSharp,
  IoChatbubbleEllipsesOutline,
  IoMenuOutline
} from "react-icons/io5";
import { FaRegFilePdf } from "react-icons/fa";
import { TbColumns1, TbColumns2, TbColumns3 } from "react-icons/tb";
import { Auth } from "../../../@core/auth";
import KeyList from "./KeyList";
import Spinner from "../../widgets/UI/Spinner";

const flatKey = [
  "C",
  "G",
  "D",
  "A",
  "E",
  "B",
  "Gb",
  "Db",
  "Ab",
  "Eb",
  "Bb",
  "F"
];
const sharpKey = [
  "C",
  "G",
  "D",
  "A",
  "E",
  "B",
  "F#",
  "C#",
  "G#",
  "D#",
  "A#",
  "F"
];
const chordCheck = [
  "Ab",
  "Eb",
  "Bb",
  "Gb",
  "Db",
  "F#",
  "C#",
  "G#",
  "D#",
  "A#",
  "F",
  "C",
  "G",
  "D",
  "A",
  "E",
  "B"
];

const SongFullScreen = ({ selectedSongs, closeFullScreen, scroll }: any) => {
  // const [flexCol, setFlexCol] = useState(
  //   Array(selectedSongs.length + 1).fill("song-body-one-column")
  // );
  // const [layout, setLayout] = useState(
  //   Array(selectedSongs.length + 1).fill(false)
  // );
  // const [fontSize, setFontSize] = useState(
  //   Array(selectedSongs.length + 1).fill(1.8)
  // );
  // const [noChords, setNoChords] = useState(
  //   Array(selectedSongs.length + 1).fill(false)
  // );
  // const [noComments, setNoComments] = useState(
  //   Array(selectedSongs.length + 1).fill(true)
  // );

  const [songSettings, setSongSettings] = useState<any>(
    Array(selectedSongs.length + 1).fill({
      noChords: false,
      noComments: true,
      layout: false,
      fontSize: 1.8
    })
  );

  const [displayButtons, setDisplayButtons] = useState(true);
  const [keyList, setKeyList] = useState(false);
  const [newKey, setNewKey] = useState(
    Array(selectedSongs.length + 1).fill("")
  );
  const [originalKey, setOriginalKey] = useState(
    selectedSongs.map((song: any) => song.key)
  );
  const [songIndex, setSongIndex] = useState(100);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [screen, setScreen] = useState("narrowScreen");
  const screenWidth = window.innerWidth;
  const carousel = useRef() as React.MutableRefObject<HTMLDivElement>;

  //LISTEN TO SCREEN ORIENTATION

  useEffect(() => {
    const updateScreen = () => {
      const w = window.innerWidth;
      const h = window.innerHeight;
      setScreen(w >= 768 && w > h ? "wideScreen" : "narrowScreen");
    };

    updateScreen();
    window.addEventListener("resize", updateScreen);
    window.addEventListener("orientationchange", updateScreen);

    return () => {
      window.removeEventListener("resize", updateScreen);
      window.removeEventListener("orientationchange", updateScreen);
    };
  }, []);

  const togleKeyList = (e: any, index: any) => {
    e.stopPropagation();
    setSongIndex(index);
    setKeyList(!keyList);
  };

  useEffect(() => {
    if (keyList) {
      document.body.addEventListener("click", () => {
        setKeyList(false);
      });
    } else {
      return;
    }
  }, [keyList]);

  const printPdf = async () => {
    const html2pdf = await require("html2pdf.js");

    const opt = {
      margin: 0.1,
      filename: "mysongs.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 3 },
      jsPDF: { unit: "in", format: "A4", orientation: "portrait" }
    };

    html2pdf()
      .set(opt)
      .from(carousel.current.innerHTML)
      .outputPdf("blob") // Get PDF as blob
      .then((pdfBlob: Blob) => {
        const pdfURL = URL.createObjectURL(pdfBlob);
        window.open(pdfURL, "_blank");
      });
  };

  //CHANGING KEY

  const changeKey = (passedKey: any) => {
    setKeyList(false);
    const changedKey = newKey.map((item: any, i: any) => {
      if (i === songIndex) {
        return (item = passedKey);
      } else {
        return item;
      }
    });
    setNewKey(changedKey);
  };
  // MANIPULATING CHORDS
  const check = /([A-G](#|b)?(m|maj|min|dim|aug|sus|add)?\d*(\/[A-G](#|b)?)?)+/;
  const exclude =
    /c|e|f|h|k|l|o|q|r|t|v|w|x|y|z|VERSE|CHORUS|TAG|VAMP|INTRO|BRIDGE|PRE|INTERLUDE/;

  const extraLines = /[*]/;
  const verseLine = /[%]/;
  const chorusLine = /[$]/;
  const bridgeLine = /[@]/;
  useEffect(() => {
    let shift = 0;
    let startKey = 0;
    let endKey = 0;
    const splitOriginal = originalKey[songIndex]?.replace("m", "");
    const splitNewKey = newKey[songIndex]?.replace("m", "");
    if (splitOriginal?.includes("#")) {
      startKey = sharpKey.indexOf(splitOriginal) + 1;
    } else {
      startKey = flatKey.indexOf(splitOriginal) + 1;
    }

    if (splitNewKey?.includes("#")) {
      endKey = sharpKey.indexOf(splitNewKey) + 1;
    } else {
      endKey = flatKey.indexOf(splitNewKey) + 1;
    }

    if (startKey > endKey) {
      shift = flatKey.length - startKey + endKey;
    } else {
      shift = endKey - startKey;
    }

    const card =
      carousel.current.children[songIndex]?.querySelectorAll(".song-body p");
    //get one song by ref
    if (songIndex !== 100) {
      const allSongs = Array.from(carousel.current.children);
      const oneSong = allSongs[songIndex].querySelectorAll(".song-body p");

      Array.from(oneSong).forEach((item: any) => {
        const checked = item.innerHTML.match(check);
        const excluded = item.innerHTML.match(exclude);
        if (checked && excluded === null) {
          chordCheck.forEach((chord) => {
            let str = "";
            let oldI = 0;
            let newChord = "";
            const checkChord = new RegExp(`\\b${chord}(?![#b])`, "g");
            const checkKey = new RegExp("(D|E|G|A|B|C#|F#|G#|A#)(?![#b])", "g");
            if (item.innerHTML.match(checkChord)) {
              if (chord.includes("b")) {
                oldI = flatKey.indexOf(chord);
              } else {
                oldI = sharpKey.indexOf(chord);
              }
              if (newKey[songIndex].match(checkKey)) {
                newChord = `-${sharpKey[(oldI + shift) % 12]}`;
              } else {
                newChord = `-${flatKey[(oldI + shift) % 12]}`;
              }
              const re = new RegExp(`(?<!-)${chord}`, "g");
              str = item.innerHTML.replaceAll(re, newChord);
              item.innerHTML = str;
            }
          });
          const final = item.innerHTML.replaceAll("-", "");
          item.innerHTML = final;
        } else {
          return;
        }
      });
    }

    const changedKey = originalKey.map((item: any, i: any) => {
      if (i === songIndex) {
        return (item = newKey[songIndex]);
      } else {
        return item;
      }
    });
    setOriginalKey(changedKey);
  }, [newKey]);

  //MAKING ALL CHORDS BLUE
  useEffect(() => {
    Array.from(carousel.current.children).forEach((el) => {
      const card = el.querySelectorAll(".song-body p");
      Array.from(card).forEach((par) => {
        const checked = par.innerHTML.match(check);
        const excluded = par.innerHTML.match(exclude);
        const comments = par.innerHTML.match(extraLines);
        const verse = par.innerHTML.match(verseLine);
        const chorus = par.innerHTML.match(chorusLine);
        const bridge = par.innerHTML.match(bridgeLine);
        if (checked && excluded === null) {
          par.classList.add("chords");
        } else {
          par.classList.remove("chords");
        }
        if (comments) {
          par.classList.add("comments");
          par.classList.add("hideScreenMode");
        } else {
          par.classList.remove("comments");
          par.classList.remove("hideScreenMode");
        }
        if (verse) {
          par.classList.add("verse");
          const final = par.innerHTML.replaceAll("%", "");
          par.innerHTML = final;
        } else if (chorus) {
          par.classList.add("chorus");
          const final = par.innerHTML.replaceAll("$", "");
          par.innerHTML = final;
        } else if (bridge) {
          par.classList.add("bridge");
          const final = par.innerHTML.replaceAll("@", "");
          par.innerHTML = final;
        } else {
          return;
        }
      });
    });
  }, []);

  //NIDING CHORDS AND COMMENTS
  useEffect(() => {
    if (songIndex !== 100) {
      const allSongs = Array.from(carousel.current.children);
      const oneSong = allSongs[songIndex].querySelectorAll(".song-body p");

      Array.from(oneSong).forEach((par) => {
        const checked = par.innerHTML.match(check);
        const excluded = par.innerHTML.match(exclude);
        const comments = par.innerHTML.match(extraLines);

        if (songSettings[songIndex].noChords && checked && excluded === null) {
          par.classList.add("hideScreenMode");
          return;
        } else {
          par.classList.remove("hideScreenMode");
        }
        if (songSettings[songIndex].noComments && comments) {
          par.classList.add("hideScreenMode");
        } else {
          par.classList.remove("hideScreenMode");
        }
      });
    }
  }, [songSettings]);

  const applySettings = (settings: any) => {
    //const allSongs = Array.from(carousel.current.children);

    Array.from(carousel.current.children).forEach((song, i) => {
      const oneSong = song.querySelectorAll(".song-body p");

      Array.from(oneSong).forEach((par) => {
        const checked = par.innerHTML.match(check);
        const excluded = par.innerHTML.match(exclude);
        const comments = par.innerHTML.match(extraLines);

        if (settings[i].noChords && checked && excluded === null) {
          par.classList.add("hideScreenMode");
          return;
        } else {
          par.classList.remove("hideScreenMode");
        }
        if (settings[i].noComments && comments) {
          par.classList.add("hideScreenMode");
        } else {
          par.classList.remove("hideScreenMode");
        }
      });
    });
  };

  const toggleChords = (index: any) => {
    //e.stopPropagation();
    setSongIndex(index);

    const newSettingsArray = songSettings.map((set: any, i: any) => {
      if (i === index) {
        return { ...set, noChords: !set.noChords };
      } else {
        return set;
      }
    });
    setSongSettings(newSettingsArray);

    // const newNoChords = noChords.map((el: any, i: any) => {
    //   if (i === index) {
    //     return (el = !el);
    //   } else {
    //     return el;
    //   }
    // });
    // setNoChords(newNoChords);
  };

  const toggleComments = (index: any) => {
    //e.stopPropagation();
    setSongIndex(index);
    const newSettingsArray = songSettings.map((set: any, i: any) => {
      if (i === index) {
        return { ...set, noComments: !set.noComments };
      } else {
        return set;
      }
    });
    setSongSettings(newSettingsArray);
    // const newNoComments = noComments.map((el: any, i: any) => {
    //   if (i === index) {
    //     return (el = !el);
    //   } else {
    //     return el;
    //   }
    // });
    // setNoComments(newNoComments);
  };

  // CHANGE LAYOUT OR FONTSIZE
  const toggleLayout = (index: any) => {
    //e.stopPropagation();
    setSongIndex(index);
    const newSettingsArray = songSettings.map((set: any, i: any) => {
      if (i === index) {
        return { ...set, layout: !set.layout };
      } else {
        return set;
      }
    });
    setSongSettings(newSettingsArray);

    // const newLayout = layout.map((el: any, i: any) => {
    //   if (i === index) {
    //     return (el = !el);
    //   } else {
    //     return el;
    //   }
    // });
    // setLayout(newLayout);
  };

  //CHANGING FONT SIZE

  const changeFontUp = (index: any) => {
    setSongIndex(index);
    const newSettingsArray = songSettings.map((set: any, i: any) => {
      if (i === index) {
        return { ...set, fontSize: set.fontSize + 0.1 };
      } else {
        return set;
      }
    });
    setSongSettings(newSettingsArray);

    // const newFont = fontSize.map((el: any, i: any) => {
    //   if (i === index) {
    //     return el + 0.1;
    //   } else {
    //     return el;
    //   }
    // });
    // setFontSize(newFont);
  };
  const changeFontDown = (index: any) => {
    setSongIndex(index);
    const newSettingsArray = songSettings.map((set: any, i: any) => {
      if (i === index) {
        return (set = { ...set, fontSize: set.fontSize - 0.1 });
      } else {
        return set;
      }
    });
    setSongSettings(newSettingsArray);
    // const newFont = fontSize.map((el: any, i: any) => {
    //   if (i === index) {
    //     return el - 0.1;
    //   } else {
    //     return el;
    //   }
    // });
    // setFontSize(newFont);
  };

  //DISPLAYING SCROLL BUTTONS

  useEffect(() => {
    const screen = window.innerWidth;
    if (selectedSongs.length !== 1) {
      if (screen <= 992 && !scroll) {
        setDisplayButtons(false);
      } else {
        setDisplayButtons(true);
      }
    } else {
      setDisplayButtons(false);
    }
  }, []);

  const carouselIncrement = (delta: any) => {
    if (carousel.current) {
      const width = carousel.current.offsetWidth;
      carousel.current.scrollTo(carousel.current.scrollLeft + width * delta, 0);
    }
  };
  useEffect(() => {
    if (!menuOpen) return;

    const handleBodyClick = () => {
      setMenuOpen(false);
    };

    document.body.addEventListener("click", handleBodyClick);

    // Cleanup when menu closes or component unmounts
    return () => {
      document.body.removeEventListener("click", handleBodyClick);
    };
  }, [menuOpen]);

  // SAVING SONG SETTINGS

  const saveOptions = async (id: any, i: any) => {
    const settings = {
      songId: id,
      setting: JSON.stringify(songSettings[i])
      // setting: JSON.stringify({
      //   layout: layout[i],
      //   noChords: noChords[i],
      //   noCommnets: noComments[i],
      //   fontSize: fontSize[i]
      // })
    };

    try {
      setIsLoading(true);
      await RestClient.saveSongSetting(settings);
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
    setMenuOpen(false);
  };

  useEffect(function () {
    const songIds = selectedSongs.map((song: any) => song.id);

    let updatedSongSettings = [...songSettings];
    (async () => {
      try {
        setIsLoading(true);
        const response = await RestClient.getSongSetting(songIds);

        selectedSongs.forEach((song: any, index: number) => {
          const settingRecord = response.find(
            (item: any) => item.songId === song.id
          );

          if (settingRecord?.setting) {
            let parsedSetting = {};
            try {
              parsedSetting = JSON.parse(settingRecord.setting);
            } catch (parseError) {
              console.warn(
                `Failed to parse setting for song ${song.id}`,
                parseError
              );
              return; // skip this song if JSON is corrupted
            }

            // Only update if we have valid parsed setting
            if (parsedSetting !== undefined) {
              updatedSongSettings = updatedSongSettings.map(
                (set: any, i: any) => {
                  if (i === index) {
                    return (set = parsedSetting);
                  } else {
                    return set;
                  }
                }
              );
            } else {
              return;
            }
          }

          // If no setting exists → do nothing (keep current values or defaults)
        });
      } catch (error) {
        console.log(error);
      }
      setSongSettings(updatedSongSettings);
      applySettings(updatedSongSettings);
      setIsLoading(false);
    })();
  }, []);

  return (
    <div className="full-screen">
      <div ref={carousel} className="full-screen-inner">
        {selectedSongs.map((item: any, i: any) => (
          <div key={item.id} className="card">
            {isLoading ? <Spinner /> : ""}
            <div className="title-line">
              {displayButtons ? (
                <>
                  <div
                    className="bigBtn bigLeft"
                    onClick={() => carouselIncrement(-1)}
                    data-html2canvas-ignore
                  >
                    <div className="bigBtn-carousel-btn btn-left"></div>
                  </div>
                  <div
                    className="bigBtn bigRight"
                    onClick={() => carouselIncrement(1)}
                    data-html2canvas-ignore
                  >
                    <div className="bigBtn-carousel-btn btn-right"></div>
                  </div>
                </>
              ) : (
                ""
              )}
              <div className="title-line-head">
                <p className="title-line-title">{item.title}</p>
                <div className="my-tooltip title-icon">
                  <IoMenuOutline
                    //className="title-icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      setMenuOpen(!menuOpen);
                    }}
                  />
                  <span className="my-tooltip-text tooltips-songbook">
                    Меню
                  </span>
                </div>
              </div>
              {menuOpen ? (
                <div
                  className="menu"
                  onClick={(e) => e.stopPropagation()}
                  data-html2canvas-ignore
                >
                  <div className="title-line-inner">
                    <div className="key">
                      <div onClick={(e) => togleKeyList(e, i)}>
                        <input
                          type="text"
                          className="title-line-key"
                          value={originalKey[i]}
                          onChange={() => console.log("")}
                        />
                        {keyList ? (
                          <IoChevronUpOutline className="key-icon" />
                        ) : (
                          <IoChevronDownOutline className="key-icon" />
                        )}
                      </div>

                      {keyList ? (
                        <div className="key-box">
                          <KeyList changeKey={changeKey} />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* <p className="title-line-key">{item.key}</p> */}
                    {item.tempo ? (
                      <p className="title-line-tempo">
                        tempo {item.tempo}, {item.time}
                      </p>
                    ) : (
                      ""
                    )}
                    <div className="buttons">
                      <button
                        className={
                          songSettings[i].noChords
                            ? "chords-show btnOff"
                            : "chords-show"
                        }
                        onClick={() => toggleChords(i)}
                      >
                        <IoMusicalNotesSharp />
                      </button>
                      <button
                        className={
                          songSettings[i].noComments
                            ? "comments-show btnOff"
                            : "comments-show"
                        }
                        onClick={() => toggleComments(i)}
                      >
                        <IoChatbubbleEllipsesOutline />
                      </button>
                      {screenWidth > 600 ? (
                        <button
                          className={
                            songSettings[i].layout
                              ? "comments-show"
                              : "comments-show btnOff"
                          }
                          onClick={() => toggleLayout(i)}
                        >
                          <TbColumns2 />
                        </button>
                      ) : null}

                      <button className="printBtn" onClick={printPdf}>
                        <FaRegFilePdf />
                      </button>
                    </div>
                  </div>
                  <div className="change-font-size font-position">
                    Aa
                    <div className="change-font-size-arrows">
                      <IoChevronUpOutline
                        className="icon"
                        onClick={() => changeFontUp(i)}
                      />
                      <IoChevronDownOutline
                        className="icon"
                        onClick={() => changeFontDown(i)}
                      />
                    </div>
                  </div>
                  {Auth.isAuthenticated ? (
                    <div className="my-tooltip">
                      <button
                        className="btn-mcolor"
                        onClick={() => saveOptions(item.id, i)}
                      >
                        Save
                      </button>
                      <span className="my-tooltip-text tooltips-songbook">
                        Зберегти налаштування для цієї пісні
                      </span>
                    </div>
                  ) : null}
                </div>
              ) : (
                ""
              )}
              <IoCloseOutline
                onClick={closeFullScreen}
                className="close-icon"
              />
            </div>
            <div className="song-body">
              <div
                dangerouslySetInnerHTML={{
                  __html: draftToHtml(JSON.parse(item.text))
                }}
                style={{ fontSize: `${songSettings[i].fontSize}rem` }}
                className={
                  songSettings[i].layout
                    ? `song-body-text ${screen}`
                    : "song-body-one-column"
                }
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default SongFullScreen;
